









































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import Role from '@/store/entities/role';
import Ajax from '../../../lib/ajax';
@Component({
    name:'createRole'
})
export default class CreateRole extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    bearerOrg: any = [];
    role:Role=new Role();
    get permissions(){
        return this.$store.state.role.permissions
    }
    save(){
        (this.$refs.roleForm as any).validate(async (valid:boolean)=>{
            if(valid){
                if(!this.role.permissions){
                    this.role.permissions=[];
                }else{                        
                    this.role.permissions = (this as any).$refs.addRole.getCheckedNodes();
                    this.role.permissions = this.role.permissions.map((item:any)=>{
                        return item.name;
                    })
                }
                await this.$store.dispatch({
                    type:'role/create',
                    data:this.role
                });
                (this.$refs.roleForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input',false);
                this.$Message.success('新增成功!');
            }
        })
    }
    cancel(){
        (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
    mounted() {
        // 获取部门信息
        Ajax.get('/api/services/app/Organization/GetAllOrganizationAsync')
            .then( (res: any) => {
                if (res.data) {
                    this.bearerOrg = res.data.result;
                }
            } )
    }
    roleRule={
        name:[{required: true,message:'请填写角色名称',trigger: 'blur'}],
        displayName:[{required:true,message:'请填写显示名称',trigger: 'blur'}]
    }
}
